import classNames from 'classnames';
import FlatCard from './FlatCard';
import React, { CSSProperties, ReactNode } from 'react';

export interface ActivityListData {
  id: string;
  type: string;
  color: string;
  image: string;
  title: string;
  cardtext: string;
  amount: number;
  formatAmount: string;
  cardtextraw: string;
  date: string;
}

interface ActivityListProps {
  listData: ActivityListData[];
  containerClassName?: string;
  containerStyle?: CSSProperties;
  children?: ReactNode;
}

const ActivityList = ({
  listData,
  containerClassName = '',
  containerStyle = {},
  children = null
}: ActivityListProps) => {
  return (
    <ul className={classNames('', containerClassName)} style={containerStyle}>
      {listData.map(({ id, cardtextraw, date, formatAmount, image }) => (
        <FlatCard
          as="li"
          key={id}
          title={{ text: cardtextraw }}
          titleClassName="font-body text-gray-700"
          subTitle={{ text: date.toString() }}
          textRight={{ text: formatAmount }}
          subTitleClassName="font-body text-xs text-gray-600"
          imageLeft={image}
          containerClassName="py-4 px-4 mb-3"
        />
      ))}
      {children}
    </ul>
  );
};

export default ActivityList;
